import {RouteConfig} from 'vue-router';
import {ProductType} from '@/commons/enums/ProductType';
import EnvironmentProducts, {Product} from '@/env/services/EnvironmentProducts';
import {Routes} from '@/router/Routes';
import {createRoutesPerProductTypes} from '@/services/CreateRoutesPerProductTypes';
import EnvironmentService from '@/env/EnvironmentService';
import GoToService from '@/router/GoToService';
const ProvisionInvoices = () => import(/* webpackChunkName: "AI" */ '@/modules/ai/provision-invoices.vue');

const ProvisionList = () => import(/* webpackChunkName: "Provisions" */ '@/modules/provisions/views/ProvisionList.vue');
const ProvisionTools = () => import(/* webpackChunkName: "Provisions" */ '@/modules/provisions/views/ProvisionTools.vue');

function createProvisionRoute(productType: ProductType): RouteConfig {
  const product: Product = EnvironmentProducts().find(x => x.type === productType)!;
  return {
    path: `${productType}`,
    name: `${Routes.PROVISION.LIST(productType)}`,
    component: ProvisionList,
    meta: {
      icon: product.icon,
      title: product.nominative?.male,
      productType,
      minNavigation: true,
    },
  };
}
export const ProvisionsRoutes: RouteConfig[] = [
  {
    path: '/provisions',
    name: 'GENERATE_SETTLEMENTS',
    beforeEnter() {
      GoToService.lendiV3('app/settlements/generate-settlements');
    },
    meta: {
      icon: 'mdi-arrow-collapse',
      title: 'Generator Zestawień',
      condition: () => EnvironmentService.Environment.isPreprodOrDev,
    },
  },
  {
    path: '/provision-tools',
    name: 'TOOLS',
    component: ProvisionTools,
    meta: {
      icon: 'mdi-wrench',
      title: 'Narzędzia',
    },
  },
  {
    path: '/ai/provisions-invoices',
    name: 'PROVISIONS_INVOICES',
    component: ProvisionInvoices,
    meta: {
      icon: 'mdi-file-document-outline',
      title: 'Analiza Faktur',
      badge: {
        is: true,
        text: 'AI',
        color: 'purple',
      },
    },
  },
  ...createRoutesPerProductTypes(
    [ProductType.MORTGAGE,], // remove cash for production
    createProvisionRoute,),
];
